import CardOne from '../common/card/CardOne'
import { FileText, Calendar } from 'lucide-react'

interface IReportListItemProps {
  isNew: boolean
  session: number
  date: string
  title: string
  subtitle: string
  handleReportClick: (reportId: string) => void
  id: string
}

const ReportListItem = ({ isNew, session, date, title, subtitle, handleReportClick, id }: IReportListItemProps) => {
  return (
    <div onClick={() => handleReportClick(id)}>
      <CardOne>
        <div className='flex items-center justify-between mb-2'>
          <div className='flex items-center gap-2'>
            <FileText className='w-5 h-5 text-amber-600' />
            <h3 className='text-base font-bold text-gray-800'>{session}회차</h3>
          </div>
          <div className='flex items-center gap-2'>
            {isNew && <div className='w-3 h-3 bg-amber-500 rounded-full'></div>}
            <div className='flex items-center gap-1 text-sm text-gray-500'>
              <Calendar size={14} />
              <span>{date}</span>
            </div>
          </div>
        </div>

        <div className='space-y-1'>
          <h4 className='text-sm font-medium text-gray-700 leading-relaxed'>{title}</h4>
          <p className='text-xs text-gray-500'>{subtitle}</p>
        </div>
      </CardOne>
    </div>
  )
}

export default ReportListItem
